<template>
  <div class="oem-config-page">
    <a-card :bordered="false">
      <div class="config-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <div class="page-title">OEM配置</div>
          <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
            <!-- 管理中心文件组 -->
            <a-form-item label="管理中心文件组">
              <a-input v-model:value="formState.adminCenterFile" placeholder="请输入管理中心文件组名称" />
              <div class="upload-hint">请输入管理中心文件组名</div>
            </a-form-item>
            
            <!-- 备案文字预览 -->
            <a-form-item label="备案文字预览">
              <a-input v-model:value="formState.recordText" placeholder="请输入备案文字" />
              <div class="preview-text">生成结果：{{ formState.recordText || 'XXX版权所有© XXX' }}</div>
            </a-form-item>

            <!-- 公安备案号 -->
            <a-form-item label="公安备案号">
              <a-input-group compact>
                <a-select v-model:value="formState.recordPrefix" style="width: 80px">
                  <a-select-option value="粤">粤</a-select-option>
                  <!-- 其他省份选项 -->
                </a-select>
                <a-input v-model:value="formState.recordNumber" style="width: calc(100% - 80px)" placeholder="备案号" />
              </a-input-group>
            </a-form-item>

            <!-- ICP备案号 -->
            <a-form-item label="ICP备案号">
              <a-input v-model:value="formState.icpNumber" placeholder="示例：粤ICP备xxxxxx号" />
            </a-form-item>

            <!-- 图标上传区域 -->
            <a-form-item label="图标上传">
              <div class="upload-section">
                <div class="upload-box">
                  <div class="upload-placeholder" v-if="!formState.logo">
                    <upload-outlined />
                    <span>上传</span>
                  </div>
                  <img v-else :src="formState.logo" alt="logo" />
                </div>
                <div class="upload-text">LOGO上传</div>
              </div>
            </a-form-item>

            <!-- 用户访问地址 -->
            <a-form-item label="用户访问地址">
              <a-input v-model:value="formState.accessUrl" placeholder="http://127.0.0.1:7777/app/omvib/thematicode=default" />
              <a-button type="link" class="copy-btn" @click="copyUrl">复制链接</a-button>
            </a-form-item>

            <!-- 提交按钮 -->
            <a-form-item :wrapper-col="{ offset: 4 }">
              <a-button type="primary" @click="handleSubmit">确认保存</a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { message } from 'ant-design-vue'
import { UploadOutlined } from '@ant-design/icons-vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

const formState = reactive({
  adminCenterFile: '',
  recordText: '',
  recordPrefix: '粤',
  recordNumber: '',
  icpNumber: '',
  logo: '',
  accessUrl: 'http://127.0.0.1:7777/app/omvib/thematicode=default'
})

const copyUrl = () => {
  navigator.clipboard.writeText(formState.accessUrl)
  message.success('复制成功')
}

const handleSubmit = () => {
  // 处理表单提交逻辑
  console.log('表单数据：', formState)
}
</script>

<style lang="less" scoped>
.oem-config-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: calc(100vh - 112px);

  .config-layout {
    display: flex;
    
    .side-menu {
      width: 220px;
      background: #fff;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
      border: 1px solid #e8e8e8;
    }

    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      border: 1px solid #e8e8e8;

      .page-title {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 24px;
        color: #1f2329;
      }

      .upload-hint,
      .preview-text {
        color: #86909c;
        font-size: 12px;
        margin-top: 4px;
      }

      .upload-section {
        .upload-box {
          width: 120px;
          height: 120px;
          border: 1px dashed #d9d9d9;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-bottom: 8px;

          &:hover {
            border-color: #1890ff;
          }

          .upload-placeholder {
            text-align: center;
            color: #86909c;

            .anticon {
              font-size: 24px;
              margin-bottom: 8px;
              display: block;
            }
          }

          img {
            max-width: 100%;
            max-height: 100%;
          }
        }

        .upload-text {
          color: #86909c;
          font-size: 12px;
        }
      }

      .copy-btn {
        margin-left: 8px;
      }
    }
  }
}
</style>